import { MDBTableHead } from 'mdb-react-ui-kit';
import React from 'react';
import './TableHeader.css';

export default function TableHeader({ ...props }: any) {
  return (
    <MDBTableHead light className={`tableHeader`}>
        {props.children}
    </MDBTableHead>
  );
}